import axios from 'axios';
import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { BASE_URL } from './BaseUrl';
import InnerHeader from './InnerHeader';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { StyledDataGrid } from './StyledDataGrid';
import { useDispatch, useSelector } from "react-redux";
import { getRoleData } from "../Store/Role/role-action";
import Cookies from "js-cookie";
import { pdf } from "@react-pdf/renderer";
import AnnualBatchReport from './Document/AnnualBatchReport';

const AnnualBatchPlan = () => {

    const [course, setCourse] = useState([])
    const [showListing, setShowListing] = useState(false);
    const [vendordata, setVendorData] = useState([])
    const [error, setError] = useState({})
    const [loading, setLoading] = useState(true)
    const [paginationModel, setPaginationModel] = useState({
        pageSize: 50,
        page: 0,
    });



    const [value, setValue] = useState({

        Course_Id: '',
        year: '',
        toyear: ''


    })

    const getCourseData = () => {

        const data = {
            tablename: "Course_Mst",
            columnname: "Course_Id,Course_Name"
        }

        axios.post(`${BASE_URL}/get_new_data`, data)
            .then((res) => {
                console.log(res.data)
                setCourse(res.data)
            })
            .catch((err) => {
                console.log(err)
            })

    }

    const [pdfdata, setpdfData] = useState([]);

    // async function getDetails() {
    //     const param = {
    //         Course_Id: value.Course_Id,
    //         toyear: value.year,
    //         fromyear: value.toyear,
    //     };

    //     axios.post(`${BASE_URL}/getannualbatchplanreport`, param).then((res) => {
    //         setpdfData(res.data);
    //         annualbatchplanreport(res.data)
    //     });
    // }

    const annualbatchplanreport = async (data) => {
        const blob = await pdf(<AnnualBatchReport data={vendordata} />).toBlob();
        const url = URL.createObjectURL(blob);
        window.open(url);
        URL.revokeObjectURL(url);
    };

    function formatDate(date) {
        // Convert to Date object if it's not already
        const d = new Date(date);

        const day = d.getDate(); // no leading zero (1 → 1, not 01)
        const month = d.getMonth() + 1; // months are 0-based
        const year = d.getFullYear();

        return `${day}-${month}-${year}`;
    }


    useEffect(() => {
        getCourseData()
    }, [])



    async function getannuallist(e) {
        e.preventDefault();

        let newErrors = {};

        if (!value.year) newErrors.year = "From Year is required";
        if (!value.toyear) newErrors.toyear = "To Year is required";
        if (!value.Course_Id) newErrors.Course_Id = "Course_Id is required";

        setError(newErrors);

        if (Object.keys(newErrors).length > 0) return; // Stop if errors

        const param = {
            Course_Id: value.Course_Id,
            year: value.year,
            toyear: value.toyear
        };

        axios.post(`${BASE_URL}/getannualbatchplanreport`, param).then((res) => {
            setVendorData(res.data);
            setShowListing(true);
        });
    }

    const onhandleChange = (e) => {
        const { name, value } = e.target;

        // Update form value
        setValue((prev) => {
            let updated = { ...prev, [name]: value };

            // If "year" dropdown is changed, update "fromyear" to year + 1
            if (name === 'year') {
                const nextYear = parseInt(value) + 1;
                if (!isNaN(nextYear)) {
                    updated.fromyear = nextYear.toString();
                }
            }

            return updated;
        });
    };



    const roledata = {
        role: Cookies.get(`role`),
        pageid: 54,
    };

    const dispatch = useDispatch();
    const roleaccess = useSelector((state) => state.roleAssign?.roleAssign[0]?.accessid);

    useEffect(() => {
        dispatch(getRoleData(roledata));
    }, []);



    const columns = [
        { field: 'index', headerName: 'Id', type: 'number', align: 'center', headerAlign: 'center', width: 10, filterable: false },
        { field: 'Course_Name', headerName: 'Training Programme', width: 200 },
        { field: 'Batch_code', headerName: 'Batch No', width: 200 },
        { field: 'Category', headerName: 'Category', width: 200 },
        { field: 'Timings', headerName: 'Timings', width: 200 },
        {
            field: 'SDate',
            headerName: 'Planned Start Date',
            width: 200,
            valueGetter: (params) => formatDate(params.row.SDate)
        },
        {
            field: 'ActualDate',
            headerName: 'Actual Start Date',
            width: 200,
            valueGetter: (params) => formatDate(params.row.ActualDate)
        },
        {
            field: 'Admission_Date',
            headerName: 'Last Date of Admission',
            width: 200,
            valueGetter: (params) => formatDate(params.row.Admission_Date)
        },
        {
            field: 'EDate',
            headerName: 'Training Completion Date',
            width: 200,
            valueGetter: (params) => formatDate(params.row.EDate)
        },
        { field: 'Duration', headerName: 'Duration', width: 200 },
        { field: 'Training_Coordinator', headerName: 'Training coordinator', width: 200 },
    ];


    const exportToExcel = (vendorData, year, toyear) => {
        if (!vendorData || vendorData.length === 0) {
            alert("No data to export");
            return;
        }

        const sheetData = [
            // Title row (merged later)
            [`Annual Batch Plan Report : ${year} - ${toyear}`],
            [], // Empty row
            // Headers row
            [
                'Training Program',
                'Batch No',
                'Category',
                'Timings',
                'Planned Start Date',
                'Actual Start Date',
                'Last Date of Admission',
                'Training Completion Date',
                'Duration',
                'Training Coordinator'
            ],
            // Data rows
            ...vendorData.map(row => [
                row.Course_Name,
                row.Batch_code,
                row.Category,
                row.Timings,
                formatDate(row.SDate),
                formatDate(row.ActualDate),
                formatDate(row.Admission_Date),
                formatDate(row.EDate),
                row.Duration,
                row.Training_Coordinator
            ])
        ];

        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

        // Merge the title row (A1 to J1)
        worksheet['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 9 } }];

        // Optionally style title row bold
        worksheet.A1.s = {
            font: { bold: true, sz: 14 },
            alignment: { horizontal: "center" }
        };

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "TrainingReport");

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

        saveAs(blob, `Training_Report_${year}_${toyear}.xlsx`);
    };



    const rowsWithIds = vendordata.map((row, index) => ({ index: index + 1, ...row }));

    return (

        <div class="container-fluid page-body-wrapper">
            <InnerHeader />
            <div class="main-panel">
                <div class="content-wrapper">
                    <div class="row">
                        <div class="col-lg-12 grid-margin stretch-card">
                            <div class="card">
                                <div class="card-body">
                                    <h4 class="card-title">Annual Batch Plan</h4>
                                    <hr></hr>
                                    <form class="forms-sample py-3" >
                                        <div class='row'>


                                            <div class="form-group col-lg-4">
                                                <label for="exampleFormControlSelect1">Select Course<span className='text-danger'>*</span> </label>
                                                <select class="form-control" id="exampleFormControlSelect1"
                                                    value={value.Course_Id} name='Course_Id' onChange={onhandleChange}>
                                                    <option>Select Course</option>
                                                    {course.map((item) => {
                                                        return (
                                                            <option value={item.Course_Id}>{item.Course_Name}</option>

                                                        )
                                                    })}
                                                </select>
                                                {<span className="text-danger"> {error.Course_Id} </span>}
                                            </div>


                                            <div class="form-group col-lg-4">
                                                <label for="exampleFormControlSelect1">Select Year<span className='text-danger'>*</span> </label>
                                                <select class="form-control form-control-lg" id="exampleFormControlSelect1" value={value.year} onChange={onhandleChange} name='year'>
                                                    <option value="">Select Year</option>
                                                    <option>2026</option>
                                                    <option>2025</option>
                                                    <option>2024</option>
                                                    <option>2023</option>
                                                    <option>2022</option>
                                                    <option>2021</option>
                                                    <option>2020</option>
                                                    <option>2019</option>
                                                    <option>2018</option>
                                                    <option>2017</option>
                                                    <option>2016</option>
                                                    <option>2015</option>
                                                    <option>2014</option>
                                                    <option>2013</option>
                                                    <option>2012</option>
                                                    <option>2011</option>
                                                    <option>2010</option>
                                                    <option>2009</option>
                                                    <option>2008</option>
                                                    <option>2007</option>
                                                    <option>2006</option>
                                                    <option>2005</option>
                                                    <option>2004</option>
                                                    <option>2003</option>
                                                    <option>2002</option>
                                                </select>
                                                {<span className="text-danger"> {error.year} </span>}
                                            </div>

                                            <div class="form-group col-lg-4">
                                                <label for="exampleInputUsername1"></label>
                                                <input type="text" class="form-control" id="exampleInputUsername1" value={value.toyear} placeholder="To Year" name='toyear' onChange={onhandleChange} />
                                                {<span className="text-danger"> {error.toyear} </span>}
                                            </div>
                                            <div class="form-group col-lg-12">
                                                <button type="submit" onClick={getannuallist} class="btn btn-primary mr-2">Go</button>
                                            </div>

                                        </div>





                                    </form>

                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12">
                            <div class="card">
                                <div class="card-body">
                                    <div className='d-flex justify-content-between' style={{ borderBottom: "2px solid #dce4ec", width: "100%" }}>
                                        <div>
                                            <h4 class="card-title">Annual Batch Plan Report</h4>
                                        </div>

                                    </div>
                                    {showListing && (
                                        <div style={{ borderLeft: "1px solid #dce4ec", height: "510px", overflow: "hidden" }}>
                                            <StyledDataGrid
                                                rows={rowsWithIds}
                                                columns={columns}
                                                // disableColumnFilter
                                                disableColumnSelector
                                                disableDensitySelector
                                                rowHeight={35}
                                                getRowId={(row) => row.Batch_Id}
                                                pagination
                                                paginationModel={paginationModel}
                                                onPaginationModelChange={setPaginationModel}
                                                pageSizeOptions={[50]}
                                                autoHeight={false}
                                                sx={{
                                                    height: 500, // Ensure enough height for pagination controls
                                                    '& .MuiDataGrid-footerContainer': {
                                                        justifyContent: 'flex-end',
                                                    },
                                                }}
                                                slots={{
                                                    toolbar: GridToolbar
                                                }}
                                                slotProps={{
                                                    toolbar: {
                                                        showQuickFilter: true,
                                                    },
                                                }}
                                            />


                                        </div>
                                    )}
                                    <button class="btn btn-primary mr-2" onClick={() => exportToExcel(vendordata, value.year, value.toyear)}>
                                        Export to Excel
                                    </button>

                                    <button type="button" class="btn btn-primary mr-2" onClick={annualbatchplanreport} >Print</button>

                                    <button type='button' onClick={() => {
                                        window.location.reload()
                                    }} class="btn btn-primary mr-2">Back</button>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </div >

    )
}

export default AnnualBatchPlan
